import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { hasLandingPagesPermissions } from "@services/useLandingPagesPermissions";

const LandingPages = lazy(() =>
  import("@scenes/MessageComposition/LandingPages/LandingPages").then((module) => ({
    default: module.LandingPages,
  }))
);

export const landingPagesNRO: NavigationRoutingObject = {
  section: "messaging",
  Component: LandingPages,
  // This feature does not have non-NRO flow so we don't need to check for the NRO component feature flipper.
  // eslint-disable-next-line local-eslint-rules/enforce-nro-component-feature-flipper-use
  componentFeatureFlippers: ["landing_pages"],
  heading: (t: I18nT<"dashboard-navigation">) => t("landing-pages-nro-heading", "Landing Pages"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "landing-pages-nro-description",
      "Build standalone web pages that drive conversions and grow your subscriber list"
    ),
  icon: "new-nav-system-landing-pages",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const isLandingPagesEnabled = featureOn("landing_pages");
    const { canReadLandingPages } = hasLandingPagesPermissions({
      hasPermission,
    });

    return isLandingPagesEnabled && canReadLandingPages;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/landing_pages/:appGroupId",
};
